import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CContainer, CSpinner } from "@coreui/react";
import { Suspense } from "react";
import { adminRoutes } from "../../rutas";
import { RutaPrivada } from "../../Rutas/RutaPrivada";
import { Loader } from "../../Components/Loader/Index";
import { BackdropGenesis } from "../../Components/Backdrop/Index";
import { storageService } from "Services/storage_service";
import { RUTAS } from "../../rutas";
import { ROLES } from "../../Constantes/constants";
import "./Contenido.css";

const Contenido = () => {
  const user = storageService.getItem("user");
  const fallbackRoute =
    user?.idRol === ROLES.NO_CLIENTE.ID ? RUTAS.PRINCIPAL : RUTAS.ADMIN_HOME;

  return (
    <CContainer fluid>
      <BackdropGenesis
        label={"Espere un momento "}
        loader={<Loader />}
      ></BackdropGenesis>
      <Suspense fallback={<CSpinner color="primary" />} />
      <Routes>
        {adminRoutes.map((route, i) => {
          return (
            route.element && (
              <Route
                key={i}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={
                  <RutaPrivada>
                    <route.element />
                  </RutaPrivada>
                }
              />
            )
          );
        })}
        <Route
          path="*"
          exact
          element={<Navigate to={fallbackRoute} replace />}
        />
      </Routes>
    </CContainer>
  );
};

export default React.memo(Contenido);
